var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00960732 0V2.31H0.779607C2.48054 2.31 3.85961 3.68907 3.85961 5.39V11.55C4.65348 11.55 5.61434 11.1662 5.91695 11.0191C6.23804 10.8628 6.58849 10.7853 6.93961 10.7845V5.39C6.93961 3.68907 8.31868 2.31 10.0196 2.31C11.7205 2.31 13.0996 3.68907 13.0996 5.39V10.7845C13.4546 10.7837 13.8094 10.8619 14.1328 11.0236C14.4254 11.1661 15.3857 11.55 16.1796 11.55V5.39C16.1796 3.68907 17.5587 2.31 19.2596 2.31H20.0296V0H0.00960732Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.5f07593493d3d95d3092ffe32e0e6273.svg";
export { ForwardRef as ReactComponent };